// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__3vuXo","Icons":"Skills_Icons__2XZNb","languageAnimation":"Skills_languageAnimation__s_rJ0","Icons2":"Skills_Icons2__3b8KF","Other":"Skills_Other__B1GkT"};